import React from "react";
import { UseCtaStateResult } from "../../hooks/useCtaState";
import { CtaStrategy } from "../../config/CtaStrategyConfig";
import "./styles/SliderCta.css";

interface SliderCtaProps {
  cta: CtaStrategy;
  ctaState: UseCtaStateResult;
}

const SliderCta: React.FC<SliderCtaProps> = ({ cta, ctaState }) => {
  const {
    offerMade, madePrice,
    trackRef, slideX, sliderStatus, shimmer, KNOB_W,
    beginSlide, beginSlideTouch, onTrackTap, labelOpacity,
  } = ctaState;

  if (offerMade) {
    return (
      <div className="sldcta__bar" aria-live="polite">
        <div className="sldcta__made-badge">
          <span className="sldcta__made-icon">✔</span>
          <span className="sldcta__made-text">Offer made</span>
          <span className="sldcta__made-price">₹{madePrice ?? "-"}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="sldcta__bar" aria-label="Slide to offer">
      <div className="sldcta__wrapper">
        <div
          className={`sldcta__track${sliderStatus === "complete" ? " sldcta__track--complete" : ""}`}
          ref={trackRef}
          onClick={(e) => onTrackTap(e as any)}
        >
          <div
            className={`sldcta__fill${shimmer ? " sldcta__fill--shimmer" : ""}`}
            style={{ width: `${slideX + KNOB_W / 2}px` }}
          />
          <span
            className="sldcta__knob"
            style={{ left: `${slideX}px` }}
            onMouseDown={beginSlide}
            onTouchStart={beginSlideTouch}
          >
            {">>"}
          </span>
          <span
            className="sldcta__label"
            style={{ opacity: labelOpacity() }}
          >
            {cta.primaryLabel}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SliderCta;
